import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { formatPrice } from "@/lib/utils";
import { slugifyOutlet } from "@/lib/guaranteedOutlets";
import OutletLogo from "./OutletLogo";

export default function OutletCard({ outlet }) {
  const slug = slugifyOutlet(outlet.name);
  const hasPage = !!outlet.has_outlet_page;
  const href = hasPage ? `/outlets/${slug}` : "https://digital24.com/register";
  const LinkComponent = hasPage ? Link : "a";
  const linkProps = hasPage ? { to: href } : { href };

  return (
    <LinkComponent
      {...linkProps}
      className="block bg-[rgba(255,255,255,0.58)] backdrop-blur-xl border border-[rgba(255,255,255,0.85)] rounded-2xl px-6 py-5 hover:-translate-y-0.5 transition-all duration-200 group/card relative focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgba(124,58,237,0.4)] focus-visible:ring-offset-2"
      style={{ boxShadow: "0 12px 32px rgba(90,60,160,0.08)" }}
    >
      <div className="flex items-center justify-center h-14 mb-5 max-w-full overflow-hidden">
        <OutletLogo
          logo={outlet.logo}
          name={outlet.name}
          scale={outlet.scale}
          maskLogo={outlet.maskLogo}
          invertLogo={outlet.invertLogo}
          colorLogo={outlet.colorLogo}
          darkBgColorLogo={outlet.darkBgColorLogo}
          opaqueLogo={outlet.opaqueLogo}
        />
      </div>
      <div className="flex items-end justify-between gap-3">
        <div className="min-w-0">
          <div className="flex flex-wrap items-center gap-1.5 mb-2">
            {outlet.sector && (
              <span className="inline-block text-[10px] font-medium px-2 py-0.5 rounded-full bg-[rgba(124,58,237,0.1)] text-[#7c3aed]">
                {outlet.sector}
              </span>
            )}
            {outlet.region && (
              <span className="inline-block text-[10px] font-medium px-2 py-0.5 rounded-full border border-[rgba(28,28,32,0.08)] text-[#6c6c74]">
                {outlet.region}
              </span>
            )}
          </div>
          <div className="flex items-center gap-2">
            <span className="font-mono text-sm font-semibold text-[#1c1c20]">DA {outlet.da}</span>
            {outlet.tier && <span className="text-[10px] text-[#8e8e96]">{outlet.tier}</span>}
          </div>
          <div className="flex items-center gap-1 mt-1">
            <span className="font-mono text-[10px] uppercase tracking-wider text-[#8e8e96]">Reach</span>
            <span className="font-mono text-xs text-[#6c6c74]">{outlet.reach || "—"}</span>
          </div>
        </div>
        <div className="flex items-center gap-1 shrink-0">
          {outlet.price != null ? (
            <span className="font-heading text-sm font-bold text-[#1c1c20] whitespace-nowrap">
              ${formatPrice(outlet.price)}
            </span>
          ) : (
            <span className="w-16" />
          )}
          <ArrowUpRight className="w-4 h-4 text-[#8e8e96] group-hover/card:text-[#7c3aed] transition-colors" />
        </div>
      </div>
    </LinkComponent>
  );
}